import { useCallback, useEffect, useMemo, useRef, useState } from 'react';

import { Container } from './styles';
import { ReactComponent as TimerIcon } from '../../assets/icons/timer2.svg';

type TimerPropTypes = {
  seconds: number;
  startDate: Date;
  paused: boolean;
};

export const Timer = ({ seconds, startDate, paused }: TimerPropTypes) => {
  const computeTimeLeft = () =>
    Math.max(0, seconds - Math.floor((Date.now() - startDate.getTime()) / 1000));

  const [timeLeft, setTimeLeft] = useState<number>(computeTimeLeft());

  const intervalIdRef = useRef<NodeJS.Timeout | null>(null);
  const createTimerInterval = useCallback(() => {
    if (intervalIdRef.current) {
      clearInterval(intervalIdRef.current);
    }
    intervalIdRef.current = setInterval(() => {
      const next = computeTimeLeft();
      setTimeLeft(next);
      if (next <= 0 && intervalIdRef.current) {
        clearInterval(intervalIdRef.current);
      }
    }, 1000);
  }, [computeTimeLeft]);

  useEffect(() => {
    if (paused) return;
    setTimeLeft(computeTimeLeft());

    createTimerInterval();

    return () => {
      if (intervalIdRef.current) {
        clearInterval(intervalIdRef.current);
      }
    };
  }, [seconds, startDate, paused]);

  const timeToRender = useMemo(() => {
    const minutesLeft = Math.trunc(timeLeft / 60);
    const secondsLeft = String(timeLeft % 60).replace(/^(\d)$/, '0$1');
    return `${minutesLeft}:${secondsLeft}`;
  }, [timeLeft]);

  return (
    <Container>
      <TimerIcon />
      <p>{timeToRender}</p>
    </Container>
  );
};
